module.exports = __webpack_public_path__ + "fonts/187f624521bea06b1d9d9e633897bbe6.txt";